import { SET_LOCATION } from "../actions/types";

export default function (state = null, action) {
  switch (action.type) {
    case SET_LOCATION:
      return {
        ...state,
        location: action.payload,
      };
    default:
      return state;
  }
}
